import { getEncryptionCachedData, cacheEncryptionData } from './caching.js';
import { decodeKeyJwk } from './utils/client.js';
import { getCloudPublicKeyRequest } from '../firebaseConfig/cloudFunctions.js';

/**
 * Get the cloud public key from local storage.
 * If not present, fetch from cloud function and store locally.
 * @return {Promise<CryptoKeyResponse>}
 */
const getCloudPublicKey = async () => {
    const keyCacheLocation = 'cloudPublicKey';
    const versionCacheLocation = 'cloudPublicKeyVersion';
    let key = getEncryptionCachedData(keyCacheLocation);
    let version = getEncryptionCachedData(versionCacheLocation);
    if (!key || !version) {
        const keyResponse = await getCloudPublicKeyRequest();
        key = keyResponse.key;
        version = keyResponse.version;
        cacheEncryptionData(keyCacheLocation, key);
        cacheEncryptionData(versionCacheLocation, version);
    }
    const decodedKey = await decodeKeyJwk(key, 'public');
    return { key: decodedKey, version };
};

export { getCloudPublicKey };
